define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.push;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/push.js
// module id = 131
// module chunks = 0